import { AVATAR_COLORS } from '@/shared/styles/avatar-colors';
import { hashStringToNumber } from '@/shared/utils/hash-string-to-number';
import { cn } from '@/shared/utils/index';

export const CharacterAvatar = ({ name, className }: { name: string; className?: string }) => {
  const hash = hashStringToNumber(name);
  const bgColor = AVATAR_COLORS[hash % AVATAR_COLORS.length];
  return (
    <div
      className={cn(
        'flex size-8 items-center justify-center overflow-hidden rounded-[50%] text-white',
        className,
      )}
      style={{ backgroundColor: bgColor }}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  );
};
